module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-copyright element-without-heading",
    attrs: {
      "id": "copyright"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "copyright-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width copyright-content"
  }, [_vm._v("This is a work of fiction. Names, characters, organizations, places, events, and incidents are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "implicit-break basic-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("Text copyright © 2014 CJ Lyons")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "implicit-break basic-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("No part of this book may be reproduced, or stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without express written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "implicit-break basic-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("Published by Thomas & Mercer, Seattle")]), _vm._v(" "), _c('p', {
    staticClass: "implicit-break basic-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("www.apub.com")]), _vm._v(" "), _c('p', {
    staticClass: "implicit-break basic-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("Amazon, the Amazon logo, and Thomas & Mercer are trademarks of Amazon.com, Inc., or its affiliates.")]), _vm._v(" "), _c('p', {
    staticClass: "implicit-break basic-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("ISBN-13: 9781477825785")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("ISBN-10: 1477825789")]), _vm._v(" "), _c('p', {
    staticClass: "implicit-break basic-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("Cover design by Inkd")]), _vm._v(" "), _c('p', {
    staticClass: "implicit-break basic-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("Library of Congress Control Number: [TK]")]), _vm._v(" "), _c('p', {
    staticClass: "implicit-break basic-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("Printed in the United States of America")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-851a313e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 69
// module chunks = 0